import React from 'react';
import { connect } from 'react-redux';
import TextField from '@mui/material/TextField';

import { RoleTypeSelector } from './Selectors';
import RolePermissions from './RolePermissions';

import './role-edit.css';

const RoleEdit = ({ data, userOrgId, onChange }) => {
  const { id, name, description, org_id, role_type_id, editable_permissions } = data;
  const handleChange = (fieldName) => (event) =>
    onChange({ ...data, [fieldName]: event.target.value });
  // eslint-disable-next-line camelcase
  if (org_id === null) {
    onChange({ ...data, org_id: userOrgId });
  }
  return (
    <div className="role-edit">
      <form noValidate autoComplete="off">
        <div className="line">
          <TextField label="Role id" value={id < 1 ? 'New Role' : id} disabled />
          <TextField label="Role name" value={name} onChange={handleChange('name')} />
        </div>
        <div className="line">
          <RoleTypeSelector
            disabled={id > 0}
            // eslint-disable-next-line camelcase
            selected={`${role_type_id}`}
            onChange={handleChange('role_type_id')}
          />
        </div>
        <div className="line">
          <TextField
            className="long-field"
            label="Role description"
            value={description}
            onChange={handleChange('description')}
          />
        </div>
        <div className="line">
          {id === -1 ? null : (
            <RolePermissions
              key={id}
              role={id}
              // eslint-disable-next-line camelcase
              roleTypeId={role_type_id}
              // eslint-disable-next-line camelcase
              editable={editable_permissions}
            />
          )}
        </div>
      </form>
    </div>
  );
};

export default connect(
  ({
    user: { orgId },
    users: {
      editing: { data },
    },
  }) => ({ data, userOrgId: orgId })
)(RoleEdit);
